var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "crown_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20957",
    d: "M0 0h18v13.5H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83215"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83174",
    transform: "translate(3 6)",
    clipPath: "url(#crown_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24864",
    d: "M5.106 5.682l2.09-3.6c.3-.52.609-1.038.905-1.562a1.034 1.034 0 011.8 0q1.413 2.445 2.837 4.884c.048.083.1.165.165.273L15.01 4.7c.5-.231.994-.459 1.488-.7a1.04 1.04 0 011.109.033.914.914 0 01.369 1q-.553 3.08-1.109 6.159c-.089.492-.174.985-.267 1.476a.957.957 0 01-.968.825c-.09.006-.181 0-.271 0H2.637c-.842 0-1.136-.231-1.28-1.026Q.688 8.77.026 5.065a.932.932 0 01.342-1.01A1.041 1.041 0 011.5 4c1.189.557 2.38 1.109 3.6 1.679"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21072",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgCrown;